export const NICKNAME_LOG_LIST_REQUEST = 'NICKNAME_LOG_LIST_REQUEST';
